import { setCurrentSessionData, setIsLoggedIn } from '../redux/app/actions';
import { toast } from 'react-toastify';
import config from '../config';
import { auth } from '../types';
import { store } from 'redux/store';

export default function onAuthSuccess(arg0: auth.TAuthResp | null) {
    const { userData } = arg0 || {};
    if (userData) store.dispatch(setCurrentSessionData(userData));
    store.dispatch(setIsLoggedIn(true));
    toast.dismiss(config.authErrorToastMessageId);
}
